<script>
export default {
  props: {
    aboutCompany: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      workDetail: '零壹科技最新職缺，投寄履歷方式如下，零壹科技歡迎您的加入:',
      worktext1: '歡迎直接至104人力銀行零壹招募專區投遞您的履歷。',
      worktext2: '暫時無適合的職缺，也歡迎直接E-mail您的履歷表至HR信箱(hr@zerone.com.tw)，我們將存入人才資料庫，待有合適職缺，會主動與您聯絡。',
      jobCard: [
        // {
        //   icon: '01logo_icon',
        //   icon1: '01logo_icon',
        //   icon2: '01logo_white_icon',
        //   name: '零壹科技',
        //   text: 'HR電子信箱',
        //   href: 'mailto:hr@zerone.com',
        // },
        // {
        //   icon: 'fblogo＿icon',
        //   icon1: 'fblogo＿icon',
        //   icon2: 'fblogo_white_icon',
        //   name: '零壹科技',
        //   text: '幸福企業粉絲團',
        //   href: 'https://www.facebook.com/zerone.fans/',
        // },
        // {
        //   icon: '104logo_icon',
        //   icon1: '104logo_icon',
        //   icon2: '104logo_white_icon',
        //   name: '人力銀行',
        //   text: '零壹招募專區',
        //   href: 'https://www.104.com.tw/company/e7ef0go?jobsource=cs_n104bank2',
        // },
      ],
    }
  },
  created() {
    const vm = this
    vm.jobCard = vm.aboutCompany.opportunity.items
  },
}
</script>
<template>
  <div :class="$style.work">
    <div class="work__box">
      <div class="container bg-overly">
        <div class="work-box">
          <BaseSectionTitle title="最新職缺" class="text-center" />
          <p class="detail">{{ workDetail }}</p>
          <div class="inner-box">
            <div class="circle-box">
              <p class="circle"></p>
              <p class="text">{{ worktext1 }}</p>
            </div>
            <div class="circle-box">
              <p class="circle"></p>
              <p class="text">{{ worktext2 }}</p>
            </div>
            <div class="job-box">
              <a v-for="(item, index) of jobCard" :key="index" class="job-card" :href="item.href" target="_blank">
                <div>
                  <img :src="item.icon" alt="" class="img" />
                  <span class="job-text">{{ item.title }}</span>
                </div>
                <div>
                  {{ item.text }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.work {
  background: $color-gray-2;
  :global {
    .work {
      &__box {
        .container {
          .work-box {
            padding-top: 70px;
            padding-bottom: 200px;
            .detail {
              margin-bottom: 60px;
              font-size: 1.125rem;
              color: $color-gray-6;
              text-align: center;
            }
            .inner-box {
              .circle-box {
                display: flex;
                align-items: center;
                margin-bottom: 25px;
                .circle {
                  width: 12px;
                  height: 12px;
                  border-radius: 30px;
                  background-color: $color-primary;
                  flex-shrink: 0;
                }
                .text {
                  font-size: 18px;
                  color: $color-gray-6;
                  margin-left: 16px;
                }
                @include max-md {
                  margin-bottom: 15px;
                  .text {
                    font-size: 12px;
                    margin-left: 12px;
                  }
                }
              }
              .job-box {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 32px;
                margin-top: 35px;
                @include max-lg {
                  font-size: 24px;
                }
                @include max-md {
                  font-size: 18px;
                }
                @include max-sm {
                  font-size: 12px;
                }
                .job-card {
                  text-align: center;
                  cursor: pointer;
                  text-decoration: none;
                  width: 32%;
                  height: 135px;
                  background-color: #ffffff;
                  color: $color-gray-8;
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  margin: 0px 15px;
                  flex-direction: column;
                  transition: all 0.1s;
                  .job-text {
                    margin-left: 12px;
                    @include max-sm {
                      margin: 0;
                    }
                  }
                  @include max-sm {
                    margin: 0 5px;
                  }
                }
                @include max-sm {
                  line-height: 1.5;
                  .img {
                    display: block;
                    margin: 0 auto;
                  }
                }
                .job-card:hover {
                  border: 1px solid $color-primary;
                }
                .job-card:hover {
                  text-decoration: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>